export default "__VITE_ASSET__d4826d98__"